declare namespace $ {

	type $mol_paragraph__title_shm_hitalama_vk_posts_plots_chart_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_plot_group__title_shm_hitalama_vk_posts_plots_chart_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
		,
		ReturnType< $mol_plot_group['title'] >
	>
	type $mol_plot_group__series_y_shm_hitalama_vk_posts_plots_chart_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
		,
		ReturnType< $mol_plot_group['series_y'] >
	>
	type $mol_plot_group__graphs_shm_hitalama_vk_posts_plots_chart_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_group['graphs'] >
	>
	type $mol_plot_mark_hor__labels_shm_hitalama_vk_posts_plots_chart_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
		,
		ReturnType< $mol_plot_mark_hor['labels'] >
	>
	type $mol_plot_mark_cross__labels_shm_hitalama_vk_posts_plots_chart_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_shm_hitalama_vk_posts_plots_chart_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	export class $shm_hitalama_vk_posts_plots_chart extends $mol_chart {
		Title( ): $mol_paragraph
		group_name( id: any): string
		series_y( id: any): readonly(any)[]
		Line( id: any): $mol_plot_line
		Dot( id: any): $mol_plot_dot
		Group( id: any): $mol_plot_group
		groups( ): readonly(any)[]
		Vert_ruler( ): $mol_plot_ruler_vert
		labels( ): readonly(string)[]
		Marker_hor( ): $mol_plot_mark_hor
		Marker_cross( ): $mol_plot_mark_cross
		group_ids( ): readonly(string)[]
		sub( ): readonly(any)[]
		graphs( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map